export default __webpack_public_path__ + "static/media/AUD-1.38a7fe6e.jpg";